// Module
var code = "<div class=\"container log-detail-container\">\n    <log-user-group-editor></log-user-group-editor>\n</div>";
// Exports
module.exports = code;